module.exports = __webpack_public_path__ + "img/Header1Kopf.ac72fd92.jpg";